import React from "react";
import styles from "./ContentBox.module.scss";

type ContentBoxProps = {
    className?: string;
};

const ContentBox: React.FC<ContentBoxProps> = (props) => {
    let className = styles["content-box"];
    if (props.className) {
        className += ` ${props.className}`;
    }

    return <div className={className}>{props.children}</div>;
};

export default ContentBox;
